import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.ProgramRobot;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "ProgramRobot.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "ProgramRobot.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "ProgramRobot.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/ProgramRobotGame/scenes/IntroductionScene.ts